import { render, staticRenderFns } from "./font.vue?vue&type=template&id=722fa024&scoped=true&"
import script from "./font.vue?vue&type=script&lang=js&"
export * from "./font.vue?vue&type=script&lang=js&"
import style0 from "./font.vue?vue&type=style&index=0&id=722fa024&lang=scss&scoped=true&"
import style1 from "./font.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./font.vue?vue&type=style&index=2&id=722fa024&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722fa024",
  null
  
)

export default component.exports